import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { Button, Form } from "react-bootstrap";
import { CSVLink } from "react-csv";
import DataTable from "react-data-table-component";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../../constants/constants";

export default function VipMemberTransactionHistory() {
  const { userId } = useParams();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    limit: limit,
    page: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [transaction, setTransaction] = useState([]);
  const [user, setUser] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [csvData, setCsvData] = useState([]);

  useEffect(() => {
    getTransactionHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, page, limit, search, startDate, endDate]);

  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const getUserDetails = () => {
    setLoading(true);

    axios
      .get(`/user/user-details-by-mongo-id/${userId}`)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const { data } = res.data;
          setUser(data);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const getTransactionHistory = () => {
    setLoading(true);

    axios
      .get(
        `/user/vip-member-transaction-history?userId=${userId}&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&type=${search}`
      )
      .then((res) => {
        setLoading(false);

        if (res.data.status) {
          setTransaction(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        message.error("Something went wrong");
      });
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format(DATE_TIME_FORMAT),
      sortable: true,
      wrap: true,
      style: {
        textAlign: "left",
        justifyContent: "flex-start",
      },
    },
    {
      name: "Type",
      selector: (row) =>
        row?.typeOfMode
          ? row?.typeOfMode === "transfer"
            ? row?.userId === user?._id
              ? "Credit Deducted"
              : "Credit Added"
            : "Code Redemption"
          : "Code Redemption",
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) =>
        row?.typeOfMode === "transfer" ? (
          <>
            {row?.userId === user?._id ? (
              <>
                <p style={{ color: "#e74c3c", fontWeight: "bold" }}>
                  -${row.amount}
                </p>
              </>
            ) : (
              <>
                <p style={{ color: "#26a69a", fontWeight: "bold" }}>
                  +${row.amount}
                </p>
              </>
            )}
          </>
        ) : (
          <>
            <p style={{ color: "#26a69a", fontWeight: "bold" }}>
              +${row.amount}
            </p>
          </>
        ),
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) =>
        row?.typeOfMode === "transfer" ? (
          <>
            <div className="desc-card">
              <div className="desc-section">
                <span className="label">From</span>
                <div className="value">
                  {row?.transferFromUserDetails?.name}
                </div>
                <div className="sub">{row?.transferFromUserDetails?.email}</div>
              </div>

              <div className="arrow">→</div>

              <div className="desc-section">
                <span className="label">To</span>
                <div className="value">{row?.transferToUserDetails?.name}</div>
                <div className="sub">{row?.transferToUserDetails?.email}</div>
              </div>
            </div>
          </>
        ) : (
          <>
            <p>{row.code}</p>
          </>
        ),
      style: {
        textAlign: "left",
        justifyContent: "flex-start",
      },
      sortable: true,
      wrap: true,
      grow: 3,
      minWidth: "300px",
    },
  ];

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);

    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const exportCSV = () => {
    setLoading(true);

    axios
      .get(
        `/user/csv-vip-member-transaction-history/${userId}?startDate=${startDate}&endDate=${endDate}&type=${search}`
      )
      .then((res) => {
        setLoading(false);

        if (res.data.status) {
          const csvData = res.data.data.map((row) => {
            const isTransfer = row?.typeOfMode === "transfer";
            const isSender = row?.userId === user?._id;

            return {
              Date: moment(row.createdAt).format(DATE_TIME_FORMAT),

              Type: isTransfer
                ? isSender
                  ? "Credit Deducted"
                  : "Credit Added"
                : "Code Redemption",

              Amount: isTransfer
                ? isSender
                  ? `-${row.amount}`
                  : `+${row.amount}`
                : `+${row.amount}`,

              Description: isTransfer
                ? `From: ${row?.transferFromUserDetails?.name || "-"} (${
                    row?.transferFromUserDetails?.email || "-"
                  }) 
To: ${row?.transferToUserDetails?.name || "-"} (${
                    row?.transferToUserDetails?.email || "-"
                  })`
                : row?.code || "-",
            };
          });

          setCsvData(csvData);

          setTimeout(() => {
            document.getElementById("csv-download-link").click();
          }, 500);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Date", key: "Date" },
    { label: "Type", key: "Type" },
    { label: "Amount", key: "Amount" },
    { label: "Description", key: "Description" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>{user?.name} Transaction History</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>

                <div className="filter_section">
                  <div className="input-group filter_fields">
                    {/* <Form.Group className="dt_range">
                      <Form.Label>Type</Form.Label>
                      <Form.Control
                        as="select"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      >
                        <option value="">Type</option>
                        <option value="credit_deducted">Credit Deducted</option>
                        <option value="credit_added">Credit Added</option>
                        <option value="code_redemption">Code Redemption</option>
                      </Form.Control>
                    </Form.Group> */}

                    <Form.Group className="dt_range">
                      <Form.Label>Start Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={selectedStartDate}
                        max={selectedEndDate || moment().format("YYYY-MM-DD")}
                        onChange={(e) => setSelectedStartDate(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group className="dt_range">
                      <Form.Label>End Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={selectedEndDate}
                        min={selectedStartDate}
                        max={moment().format("YYYY-MM-DD")}
                        onChange={(e) => setSelectedEndDate(e.target.value)}
                      />
                    </Form.Group>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setStartDate(selectedStartDate);
                        setEndDate(selectedEndDate);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      disabled={
                        !search && !selectedStartDate && !selectedEndDate
                      }
                      onClick={() => {
                        setSearch("");
                        setQuery("");
                        setSelectedStartDate("");
                        setSelectedEndDate("");
                        setStartDate("");
                        setEndDate("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={
                        "vip-member-transaction-history-" +
                        moment().format("DDMMYYYY-HHmmss") +
                        ".csv"
                      }
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={transaction}
                  pagination
                  striped
                  responsive
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);
